// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"b9907eb9","787":"f4901b49"}[chunkId] + ".chunk.js";
};